import React from 'react';
import Sidebar from '../../components/common/Sidebar';
import Navbar from '../../components/common/Navbar';
import ApproverDashboard from '../components/dashboards/ApproverDashboard';
import '../css/wrms.css';

const ApprovalsInboxPage = () => (
  <div className="d-flex wrms-page" style={{ width: '100%', maxWidth: '100vw', overflowX: 'hidden' }}>
    <Sidebar />
    <div className="flex-grow-1 wrms-main-content" style={{ minWidth: 0, maxWidth: '100vw' }}>
      <Navbar />
      <div className="wrms-container">
        <div className="wrms-page-header">
          <div className="wrms-header-info">
            <div className="wrms-breadcrumb">Requests · <span>Approvals Inbox</span></div>
            <h1 className="wrms-page-title">Approvals Inbox</h1>
            <p className="wrms-page-subtitle">Review and take action on pending requests assigned to your role.</p>
          </div>
        </div>
        <ApproverDashboard />
      </div>
    </div>
  </div>
);

export default ApprovalsInboxPage;
